package org.hs_soft.runmynesto.domain.model.home.product.tabs.tab_selection

import org.hs_soft.runmynesto.domain.util.helper.LanguageManager

enum class CourseEnum(
    val value: String,
    val title: String,
) {
    GANG_1(
        title = LanguageManager.getCurrentStrings().gang + " 1",
        value = "1",
    ),
    GANG_2(
        title = LanguageManager.getCurrentStrings().gang + " 2",
        value = "2",
    ),
    GANG_3(
        title = LanguageManager.getCurrentStrings().gang + " 3",
        value = "3",
    ),
    GANG_4(
        title = LanguageManager.getCurrentStrings().gang + " 4",
        value = "4",
    ),
    GANG_5(
        title = LanguageManager.getCurrentStrings().gang + " 5",
        value = "5",
    ),
    GANG_6(
        title = LanguageManager.getCurrentStrings().gang + " 6",
        value = "6",
    ),
    GANG_7(
        title = LanguageManager.getCurrentStrings().gang + " 7",
        value = "7",
    ),
    GANG_8(
        title = LanguageManager.getCurrentStrings().gang + " 8",
        value = "8",
    ),
}